import { render, staticRenderFns } from "./CreatingYourWill.vue?vue&type=template&id=f4a6826e&"
import script from "./CreatingYourWill.vue?vue&type=script&lang=js&"
export * from "./CreatingYourWill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports